export default __webpack_public_path__ + "static/media/2.386fdb8d.webp";